<template>
    <div class="table-responsive mb-0">
        <table class="table table-bordered bg-white table-hover">
            <thead>
                <tr>
                    <th colspan="4">INFORMACIÓN BASICA</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <th>Tipo de vehiculo</th>
                    <td colspan="3">{{ vehiculoData.tipo_vehiculo }}</td>
                </tr>
                <tr>
                    <th>Vehiculo</th>
                    <td colspan="3" class="text-uppercase">
                        {{ vehiculoData.marca }} {{ vehiculoData.linea }}
                        {{ vehiculoData.modelo }}
                    </td>
                </tr>
                <tr>
                    <th>Versión</th>
                    <td colspan="3">{{ vehiculoData.version }}</td>
                </tr>
                <tr>
                    <th>Kilometraje</th>
                    <td>{{ vehiculoData.kilometraje | formatNumber }}</td>
                    <th>Color</th>
                    <td>
                        {{ inspeccionLegalData.vehiculo.color_primario }}
                        {{ inspeccionLegalData.vehiculo.color_secundario }}
                    </td>
                </tr>
                <tr>
                    <th>Pico y Placa</th>
                    <td>
                        {{ getPicoPlaca(inspeccionLegalData.vehiculo.placa) }}
                    </td>
                    <th>Matriculado en</th>
                    <td>{{ inspeccionLegalData.vehiculo.transito.ciudad }}</td>
                </tr>
                <!--<tr>
                    <td>Unico dueño</td>
                    <td>{{ inspeccion_legal.unico_dueno }}</td>
                </tr>-->
                <tr>
                    <th>Soat</th>
                    <td>
                        {{ inspeccionLegalData.vehiculo.estado_soat }}
                        {{ inspeccionLegalData.vehiculo.fecha_soat }}
                    </td>
                    <th>Revisión Tecnomecánica</th>
                    <td>
                        {{
                            inspeccionLegalData.vehiculo.estado_tecnicomecanica
                        }}

                        {{ inspeccionLegalData.vehiculo.fecha_tecnicomecanica }}
                    </td>
                </tr>
                <tr
                    v-if="inspeccionLegalData.vehiculo.estado_blindaje === 'Si'"
                >
                    <th>Blindaje</th>
                    <td colspan="3">
                        {{ inspeccionLegalData.vehiculo.tipo_blindaje }}
                    </td>
                </tr>
                <tr>
                    <th>Peritaje</th>
                    <td colspan="3">
                        <a
                            v-if="documentosData != ''"
                            target="_blank"
                            :href="
                                'https://brokcars-assets.s3.us-east-2.amazonaws.com/' +
                                    documentosData
                            "
                        >
                            <i class="fa fa-file-pdf-o fa-2x"></i>
                        </a>
                        <span v-else>No registra</span>
                    </td>
                </tr>
                <tr>
                    <th colspan="4">Especificaciones Técnicas</th>
                </tr>
                <tr>
                    <th>Tipo de Caja</th>
                    <td>
                        {{ get_tipo_caja(vehiculoData.meta_keys.tipo_caja) }}
                    </td>
                    <th>Carroceria</th>
                    <td>{{ inspeccionLegalData.vehiculo.carroceria }}</td>
                </tr>
                <tr>
                    <th>Cilindraje</th>
                    <td>
                        {{ vehiculoData.meta_keys.clindraje | formatNumber }} cc
                    </td>
                    <th>Combustible</th>
                    <td>
                        {{
                            get_combustible(vehiculoData.meta_keys.combustible)
                        }}
                    </td>
                </tr>
                <tr>
                    <th>Puertas</th>
                    <td>{{ vehiculoData.meta_keys.puertas }}</td>
                    <th>Capacidad</th>
                    <td>{{ vehiculoData.meta_keys.capacidad }} pasajeros</td>
                </tr>
                <tr>
                    <th>Potencia</th>
                    <td>{{ vehiculoData.meta_keys.potencia }} hp</td>
                    <th>Tracción</th>
                    <td>{{ vehiculoData.meta_keys.transmision }}</td>
                </tr>
                <!-- <tr>
                    <td>Valor asegurable</td>
                    <td colspan="3">$ {{fasecoldaParse(modelorel.avaluo.vr_fasecolda)}}</td>
                </tr> -->
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    computed: {
        vehiculoData() {
            return this.$store.state.fichaTecnica.vehiculo.info_vehiculo
                .vehiculo;
        },
        documentosData() {
            return this.$store.state.fichaTecnica.vehiculo.info_vehiculo
                .documentos;
        },
        inspeccionLegalData() {
            return this.$store.state.fichaTecnica.vehiculo.tabs.ficha_tecnica;
        }
    },
    methods: {
        fasecoldaParse(fasecolda) {
            var stringReal = fasecolda + "000";
            var toInt = parseInt(stringReal);
            return toInt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },
        getPicoPlaca(placa) {
            if (placa.length == 6) return placa.charAt(5);
            else return placa;
        },
        get_combustible(code_combustible) {
            switch (code_combustible) {
                case "GSL":
                    return "Gasolina";
                    break;
                case "DSL":
                    return "Diesel";
                    break;
                case "ELT":
                    return "Electrico";
                    break;
                case "HBD":
                    return "Híbrido";
                    break;
                default:
                    return code_combustible;
            }
        },
        get_tipo_caja(code_caja) {
            switch (code_caja) {
                case "AT":
                    return "Automatica";
                    break;
                case "MT":
                    return "Mecanica";
                    break;
                case "TP":
                    return "Tiptronic";
                    break;
            }
        }
    }
};
</script>

<style lang="scss" scoped></style>
